import { resolveLocale } from '@/shared/localization';

/** preview 이미지의 기본 비율 (aspectRatio 미지정 시) */
export const PREVIEW_DEFAULT_RATIO = '16:9';

/**
 * 배너 템플릿 preview 정적 에셋 URL.
 * preview webp 는 문구가 렌더된 이미지라 로케일별 세트가 존재한다
 * (public/banner-presets/preview/{ko,en}/). 미지원 로케일은 resolveLocale 이
 * 기본 로케일로 폴백한다.
 * 템플릿 선택 썸네일도 이 1:1 에셋을 공유한다 (useBannerMeta — 과거
 * banner-presets/template/ 는 ko 1:1 과 동일 파일의 중복본이라 제거).
 */
export function getBannerPreviewUrl(
  locale: string,
  templateType: string,
  aspectRatio?: string,
): string;
export function getBannerPreviewUrl(
  locale: string,
  templateType?: string,
  aspectRatio?: string,
): string | undefined;
export function getBannerPreviewUrl(
  locale: string,
  templateType?: string,
  aspectRatio?: string,
): string | undefined {
  if (!templateType) return undefined;
  const ratioToken = (aspectRatio || PREVIEW_DEFAULT_RATIO).replace(':', '_');
  return `/banner-presets/preview/${resolveLocale(locale)}/${templateType}_${ratioToken}.webp`;
}
